import Button from '@components/Button';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';

import useWithdraw from './hooks/useWithdraw';
import styles from './styless.module.scss';

function TerminationFooter() {
  const { checked, setChecked, handleWithdraw } = useWithdraw();
  return (
        <Column fullWidth>
            <div className={styles.checkbox}>
                <Checkbox isChecked={checked}
                          toggleCheckbox={() => setChecked(!checked)} >
                    내용을 확인했습니다.
                </Checkbox>
            </div>
            <div className={styles.button}>
                <Button fullWidth
                        onClick={handleWithdraw}
                        disabled={!checked}>
                    탈퇴
                </Button>
            </div>
        </Column>
  );
}

export default TerminationFooter;
